import React from 'react';
import { Star, AlertCircle } from 'lucide-react';
import { HostStarHero, HostStarAlerts } from './HostStarHero';
import { HostCycleEarnings } from './HostCycleEarnings';
import { HostDailyStatement } from './HostDailyStatement';
import { HostPreviousCycle } from './HostPreviousCycle';
import { HostPromotionCard } from './HostPromotionCard';
import { ObsidianCard } from './StarBits';

export const HostStarPanel = ({ starData, promo, error }) => (
  <div className="space-y-3" data-testid="host-star-section">
    <div className="flex items-center gap-2.5">
      <span className="flex h-9 w-9 items-center justify-center rounded-xl border border-amber-400/30 bg-gradient-to-br from-amber-400/20 to-transparent shadow-[0_0_20px_-4px_rgba(245,158,11,0.5)]">
        <Star className="h-4 w-4 text-amber-300" strokeWidth={2.5} />
      </span>
      <div>
        <h2 className="font-display text-base font-black uppercase leading-none tracking-[0.08em] text-slate-800 sm:text-lg">
          Star Host
        </h2>
        <p className="text-[10px] text-slate-400">sua meta, seus ganhos e o extrato do ciclo</p>
      </div>
    </div>

    {error || !starData ? (
      <ObsidianCard testId="host-kako-unavailable-alert">
        <div className="flex items-start gap-2.5 text-xs text-zinc-300 sm:text-sm">
          <AlertCircle className="mt-0.5 h-4 w-4 shrink-0 text-amber-400" />
          <span>{error || 'Dados de Star Host indisponíveis agora.'} Nenhum número é exibido
            enquanto a KAKO não responder — tente novamente em instantes.</span>
        </div>
      </ObsidianCard>
    ) : starData.is_star_host ? (
      <>
        <HostStarAlerts alerts={starData.alerts} />
        {starData.maintenance && (
          <HostStarHero grade={starData.grade} status={starData.status}
            cycle={starData.cycle} maintenance={starData.maintenance} />
        )}
        {starData.earnings && <HostCycleEarnings earnings={starData.earnings} />}
        <HostDailyStatement statement={starData.statement} />
        <HostPreviousCycle />
        <HostPromotionCard promo={promo} />
      </>
    ) : (
      <>
        <ObsidianCard testId="host-star-empty" className="space-y-2">
          <p className="flex items-center gap-2 font-display text-sm font-black text-white">
            <Star className="h-4 w-4 text-amber-400" /> Você ainda não é Star Host
          </p>
          <p className="text-xs leading-relaxed text-zinc-400">
            Host novo pode solicitar direto à agência. Host antigo entra pela régua de presentes
            da sorte: <span className="font-mono text-amber-300">100.000.000</span> em dois ciclos,
            com <span className="font-mono text-amber-300">20</span> dias de live de vídeo — e aqui
            o dia vale com <span className="font-mono text-amber-300">2h</span> de vídeo. Conta
            também imagem, talento e equipamento — os detalhes estão na Política de Star Host.
          </p>
        </ObsidianCard>
        <HostPromotionCard promo={promo} />
      </>
    )}
  </div>
);

export default HostStarPanel;
